export const ResignationRequestsPaths = {
  MANAGE_REQUEST_RESIGNATION_REQUESTS: 'resignation-requests',
  MANAGE_REQUEST_CREATE_RESIGNATION_REQUEST: 'create',
  MANAGE_REQUEST_EDIT_RESIGNATION_REQUEST: 'edit/:requestId',
};
